export default "__VITE_ASSET__C_3es03Z__"